import { onReady } from "./utils/on-ready";

export class FindAgentOfficeMap {
    public static htmlId = 'find-agent-office-map';

    constructor() {
        onReady(() => {
            this.initMap();
        });
    }

    initMap = () => {
        let map;
        let markers = new Array();
        var prev_infowindow = false;
        let bounds;
        let array;
        let f = (document.getElementById('myHiddenArray') as any);
        if (f != undefined && f != null) {
            f = f.value;
        }
        let latitude = parseFloat("0");
        let longitude = parseFloat("0");
        let marker;

        bounds = new google.maps.LatLngBounds();

        if (f != undefined && f != null) {
            array = JSON.parse(f);

            if (array.length > 1) {
                array.forEach(function (officeLocation) {
                    latitude += parseFloat(officeLocation.Geo.Latitude);
                    longitude += parseFloat(officeLocation.Geo.Longitude);
                });
            }
            else if (array.length == 1) {
                latitude += parseFloat(array[0].Geo.Latitude);
                longitude += parseFloat(array[0].Geo.Longitude);
            }
            else {
                latitude += parseFloat(array.Geo.Latitude);
                longitude += parseFloat(array.Geo.Longitude);
            }

            if (latitude == 0 || longitude == 0) {
                latitude = (39.791) + -0.02;
                longitude = -86.148 + -0.02;
            } else {
                latitude = (latitude / array.length) + 0.28;
                longitude = (longitude / array.length);
            }

            var mapCenter = new google.maps.LatLng({ lat: latitude, lng: longitude });
            map = new google.maps.Map(document.getElementById('map'), {
                center: mapCenter,
                disableDefaultUI: true
            });

            if (array.length > 1) {
                array.forEach(function (officeLocation) {
                    var contentString = '<div id="content"><h1 class="f-t-md f-m-b-sm"><a target="_blank" href="' + officeLocation.OfficeMapLink + '">' + officeLocation.OfficeDescription + '</a></h1><span>' + officeLocation.Address_Formatted + '</span></div>';
                    var infowindow = new google.maps.InfoWindow({
                        content: contentString
                    });
                    var latLng = new google.maps.LatLng(parseFloat(officeLocation.Geo.Latitude), parseFloat(officeLocation.Geo.Longitude));
                    marker = new google.maps.Marker({
                        position: latLng,
                        map: map,
                        title: officeLocation.OfficeDescription
                    });
                    markers.push(marker);

                    google.maps.event.addListener(marker, 'click', (function (marker, contentString, infowindow) {
                        return function () {
                            if (prev_infowindow)
                                (prev_infowindow as any).close();

                            (prev_infowindow as any ) = infowindow;
                            infowindow.setContent(contentString);
                            infowindow.open(map, marker);

                            goToList(marker.title);
                        };
                    })(marker, contentString, infowindow));

                    [...document.querySelectorAll('.google-map__trigger-item')].map((el, i) => {
                        el.addEventListener('click', () => {
                            google.maps.event.trigger(markers[i], 'click');
                        });
                    });
                });
            }
            else if (array.length == 1) {
                var contentString = '<div id="content"><h1 class="f-t-md f-m-b-sm"><a target="_blank" href="' + array[0].OfficeMapLink + '">' + array[0].OfficeDescription + '</a></h1><span>' + array[0].Address_Formatted + '</span></div>';
                var infowindow = new google.maps.InfoWindow({
                    content: contentString
                });
                var latLng = new google.maps.LatLng(parseFloat(array[0].Geo.Latitude), parseFloat(array[0].Geo.Longitude));

                marker = new google.maps.Marker({
                    position: latLng,
                    map: map,
                    title: array[0].OfficeDescription
                });

                markers.push(marker);

                google.maps.event.addListener(marker, 'click', (function (marker, contentString, infowindow) {
                    return function () {
                        if (prev_infowindow)
                            (prev_infowindow as any).close();

                        (prev_infowindow as any) = infowindow;
                        infowindow.setContent(contentString);
                        infowindow.open(map, marker);

                        goToList(marker.title);
                    };
                })(marker, contentString, infowindow));

                [...document.querySelectorAll('.google-map__trigger-item')].map((el, i) => {
                    el.addEventListener('click', () => {
                        google.maps.event.trigger(markers[i], 'click');
                    });
                });
            }
            else {
                var contentString = '<div id="content"><h1 class="f-t-md f-m-b-sm"><a target="_blank" href="' + array.OfficeMapLink + '">' + array.OfficeDescription + '</a></h1><span>' + array.Address_Formatted + '</span></div>';
                var infowindow = new google.maps.InfoWindow({
                    content: contentString
                });
                var latLng = new google.maps.LatLng(parseFloat(array.Geo.Latitude), parseFloat(array.Geo.Longitude));

                marker = new google.maps.Marker({
                    position: latLng,
                    map: map,
                    title: array.OfficeDescription
                });

                markers.push(marker);

                google.maps.event.addListener(marker, 'click', (function (marker, contentString, infowindow) {
                    return function () {
                        if (prev_infowindow)
                            (prev_infowindow as any).close();

                        (prev_infowindow as any) = infowindow;
                        infowindow.setContent(contentString);
                        infowindow.open(map, marker);

                        goToList(marker.title);
                    };
                })(marker, contentString, infowindow));

                [...document.querySelectorAll('.google-map__trigger-item')].map((el, i) => {
                    el.addEventListener('click', () => {
                        google.maps.event.trigger(markers[i], 'click');
                    });
                });
            }

            for (var i = 0; i < markers.length; i++) {

                bounds.extend(markers[i].getPosition());
            }

            //center the map to a specific spot (city)
            map.setCenter({ lat: latitude, lng: longitude });

            //center the map to the geometric center of all markers
            map.setCenter(bounds.getCenter());

            map.fitBounds(bounds);

            google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
                this.setZoom(map.getZoom() - 1);

                if (this.getZoom() > 15) {
                    this.setZoom(15);
                }

                if (this.getZoom() < 7) {
                    this.setZoom(7);
                }
            });

            map.fitBounds(bounds);
        }

        function goToList (id) {
            document.getElementById(id.replace(' ', '_').toLowerCase() + "-list-result").scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }

    //goToList = (id) => {
    //   document.getElementById(id.replace(' ', '_').toLowerCase() + "-list-result").scrollIntoView({
    //       behavior: 'smooth',
    //       block: 'start'
    //   });
    //}
}